import { AudioPlayer } from './MusicPlayerElements';
import Music from '../music/Cybergunx.wav';

function MusicPlayer() {

    return (
        <AudioPlayer id="backgroundMusic" src={Music} loop controls />
    );
}

export default MusicPlayer;